import React from "react";
import { History } from "react-ikonate";
import { Button } from "../../Button";
import SpinningIcon from "../../SpinningIcon";
import styles from "./index.module.css";

/**
 * Fixed action bar displayed at the top right of all Add/Edit pages.
 * Contains Save, Save as Draft, and Cancel buttons.
 * When isDraft is true, renders a red "DRAFT VERSION" label on the left.
 * Optional undo/history integration (ported from the WWG Store editor):
 * pass `onShowHistory` to render a History button, and `isDirty` to show an
 * "● Unsaved" badge and disable Save while the form has no changes.
 * Optional delete button (pass `onDelete` to render it as a red button).
 */
export function FormActionBar({
  onSave,
  onSaveDraft,
  onCancel,
  onDelete,
  isDraft = false,
  embedded = false,
  isSaving = false,
  disabled = false,
  isDirty,
  onShowHistory,
}) {
 
  
  const isDisabled = isSaving || disabled;
  return (
    <div
      className={`${styles.container} ${
        embedded ? styles.embedded : ""
      }`.trim()}
    >
      {isDraft && <span className={styles.draftLabel}>DRAFT VERSION</span>}
      {isSaving && (
        <span className={styles.savingBadge}>Saving changes...</span>
      )}
      {isDirty === true && !isSaving && (
        <span className={styles.dirtyBadge}>● Unsaved</span>
      )}
      <div className={styles.actions}>
        {onShowHistory && (
          <button
            type="button"
            className={styles.historyButton}
            onClick={onShowHistory}
            disabled={isDisabled}
          >
            <History size={16} />
            <span>History</span>
          </button>
        )}
        <Button
          className={styles.saveButton}
          onClick={onSave}
          disabled={isDisabled || isDirty === false}
        >
          {isSaving && isSaving !== "draft" ? <SpinningIcon size={16} /> : "Save"}
        </Button>
        <Button
          className={styles.draftButton}
          onClick={onSaveDraft}
          disabled={isDisabled}
        >
          {isSaving === "draft" ? <SpinningIcon size={16} /> : "Save as Draft"}
        </Button>
        <Button
          className={styles.cancelButton}
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancel
        </Button>
        {onDelete && (
          <Button
            className={styles.deleteButton}
            onClick={() => {
              onDelete();
            }}
            disabled={isSaving}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  );
}

export default FormActionBar;
